module.exports = __webpack_public_path__ + "static/media/tab-img-5.3098f1f1.jpg";